export default function hauntBackgroundImage() {
  const widgetName = "hauntBackgroundImage";
  const widgetOpts = hauntBackgroundImageOpts;
  const $widgetElement = $(`#${widgetName}`);
  const mainFeatureElement = '.wrapper';

  return saffire.widgets.cardWidget($widgetElement, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        addMainFeatureBackground(data.items[0], mainFeatureElement);
        $(`#${widgetName}`).remove();
      } else {
        $widgetElement.remove();
      }
    },
  });
}

function addMainFeatureBackground(widgetData, featureTarget) {
  const { ImageWithPath } = widgetData;
  const $wrapper = $(featureTarget);

  if ($wrapper.find('.haunt-bg-fixed').length === 0) {
    $wrapper.prepend('<div class="haunt-bg-fixed"></div>');
  }

  const $hauntBg = $wrapper.find('.haunt-bg-fixed');

  $hauntBg.css({
    'background-image': `url('${ImageWithPath}')`
  });
}